import React, { useState, useEffect} from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";

import { AssessmentTwoTone } from "@material-ui/icons";
import Grid from "@material-ui/core/Grid";
import "./Settings.scss";
import {get_cookies, isLoggedIn} from "../../components/Cookies/Cookies";
import Preloader from "../../components/Preloader/Preloader";
import { Button } from "@material-ui/core";

const cssDisabled ={backgroundColor:"black"}

const Settings = () => {
	const x = 0;
		useEffect(() => { //
		isLoggedIn();
		// console.log('33',document.cookie)
	}, [x]);
	const [contentNav, setContentNav] = useState('');
	useEffect(() => { //
		
		getContentNavData();
	}, []);



	const getContentNavData = async() => {
		await axios.get(process.env.REACT_APP_API_URL+'get_content_nav_data', {
            params:{
                name: 'settings',
				content_nav: get_cookies('content.nav.access')
            }
			}).then(function (res) {
				setContentNav(res.data.data);
		  	}).catch(function (error) {	
				// console.log(error);
	  		});
	}

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<AssessmentTwoTone />
				</div>
				<h2 className="header-title">Settings</h2>
			</div>
			<div className="page-container">
					<Grid container spacing={2}>
						{contentNav ? contentNav.map((item)=>{
								return(
									<Grid item xs={12} sm={6} className="app-card-container" key={item.id} 									
									style={{
										"--cardBorderColor": item.nav_color
									}}>
										<NavLink to={item.cn_url} key={item.id}>
											<div className="app-card">
												{item.cn_name}
											</div>
										</NavLink> 
									</Grid>	
							
								)
							})
							: (<Preloader />)}
					</Grid>
			</div>
		</div>
	);
};

export default Settings;
